import { CSSPropsVars } from '@/interfaces/types/CSSPropsVars';
import { SxmLogoLetterIcon } from '@/assets/icons/SxmLogoLetterIcon';
import styles from './imagePlaceholder.module.scss';

export interface ImagePlaceholderProps {
    backgroundColor?: string;
    logoColor?: string;
}

export function ImagePlaceholder({
    backgroundColor = 'var(--base-contrast, #1E2226)',
    logoColor = 'var(--inverse-button-primary-contrast-disabled, #5A626A)',
}: ImagePlaceholderProps): React.JSX.Element {
    const customProperties: CSSPropsVars = {
        '--badge-background-color': backgroundColor,
        '--logo-color': logoColor,
    };

    return (
        <div className={styles.wrapper} style={customProperties}>
            <SxmLogoLetterIcon />
        </div>
    );
}
